<template>
    <div class="tw-p-[15px] tw-rounded-[8px] tw-bg-white">
        <div class="tw-rounded-[8px] tw-overflow-hidden tw-border tw-border-solid tw-border-[#dddddd]">
            <div :class="[timeDiff === 0 ? 'bg--change': '', 'tw-bg-[#E4E8FF] tw-px-[20px] tw-py-[10px] tw-mb-[10px]']">
                <div class='tw-flex tw-justify-between'>
                    <div class="tw-font-semibold tw-text-[#0D3659]">
                        <span>{{ delivery.items_name + ' - #' + delivery.id }}</span>
                    </div>
                    <div
                        @click="openDeliveryReviewModal"
                        class="tw-block tw-px-[15px] tw-py-[3px] tw-bg-white tw-text-[#0D3659] tw-font-semibold tw-text-[14px] tw-rounded-[8px] tw-cursor-pointer"
                    >
                        <span>See reviews</span>
                        <v-icon color="secondary" size="10" class="tw-ml-2">fa-chevron-right</v-icon>
                    </div>
                    <div v-if="showUpOrderTime" class="ml-auto ml-sm-0 card-time d-flex align-center">
                        <v-icon size="14" color="secondary" class="mr-2 ml-3">fa-clock</v-icon>
                        <span>{{ timeDiff }}</span>
                    </div>
                </div>
            </div>

            <v-card outlined tile class="rounded-b dashboard-card__main">
                <div class="tw-bg-[#F4F6FF] tw-px-4">
                    <div class="tw-w-full tw-flex tw-items-center tw-justify-between tw-flex-wrap tw-py-2">
                        <div class="tw-font-bold tw-text-[#0D3659]">
                          <v-tooltip top content-class="charge-text__tooltip" v-if="isBeingCompletedDeliveryOrder(delivery) && delivery.isAcceptorCompleted">
                            <template v-slot:activator="{ on, attrs }">
                              <div class="tw-flex tw-gap-[8px]" v-bind="attrs" v-on="on">
                                <i class="icony icony-info-circle-o tw-text-secondary"></i>
                                <span>Payment Review in Progress</span>
                              </div>
                            </template>
                            <span class="custom--v-tooltip">
                              Your request has been submitted. Admin is reviewing your signed document. This order must also be confirmed by the customer. Once verified, our team will contact you to complete your payout.
                            </span>
                          </v-tooltip>
                          <span v-else>{{ delivery.status }}</span>
                        </div>
                        <button
                            type="button"
                            class="tw-bg-[white] tw-border tw-border-solid tw-border-[#E3E8FF] tw-text-[14px] tw-rounded-[8px] tw-text-[#0D3659] tw-font-semibold hover:tw-bg-[#0D3659] hover:tw-border-[#0D3659] tw-duration-300 hover:tw-text-[#FFF] tw-px-4"
                            @click="openDeliveryDetailsModal(delivery.id)"
                        >
                            {{ isCardOpened ? "Close details" : "View details" }}
                        </button>
                    </div>
                </div>

                <div class="tw-pt-[15px] tw-px-[20px]">
                    <div
                        class="tw-flex tw-justify-between tw-gap-[35px] tw-pb-[15px] tw-border-0 tw-border-b tw-border-solid tw-border-[#DDDDDD]">
                        <div class="tw-flex tw-gap-[35px]">
                            <div class="tw-flex tw-items-center tw-justify-between tw-gap-[5px]" v-if="getVehicle">
                                <img :src="getVehicle.image" alt="" class="tw-h-[18px] tw-w-auto">
                                <span class="tw-text-[16px] tw-text-[#0D3659] tw-font-semibold tw-whitespace-nowrap"> -
                                    {{ getVehicle.name }}
                                </span>
                            </div>
                            <div class="tw-flex tw-items-center tw-text-[#0D3659] tw-font-semibold">
                                <i class="icony icony-mapmarker-clock tw-mr-[8px] tw-text-[#8F3985]"></i>
                                <span>{{ delivery.pickup }}</span>
                            </div>
                            <div class="tw-flex tw-items-center tw-text-[#0D3659] tw-font-semibold"
                                 v-if="delivery.destination">
                                <i class="icony icony-mapmarker-check tw-mr-[8px] tw-text-[#8F3985]"></i>
                                <span>{{ delivery.destination }}</span>
                            </div>
                        </div>
                        <div class="tw-text-[#0D3659] tw-font-semibold">
                          {{ "Customer phone: " + delivery.customer.phone }}
                        </div>
                    </div>
                </div>

                <div class="tw-grid tw-grid-cols-2 tw-py-[15px] tw-px-[20px]">


                  <div>
                    <div class="tw-flex max-md:tw-flex-col tw-gap-[20px] lg:tw-gap-[65px]">
                      <div class="tw-flex tw-items-start tw-gap-[10px]">
                        <i class="icony icony-calendar tw-w-[14px] tw-max-w-[14px] tw-min-w-[14px] tw-mt-[2px] tw-text-[#8F3985]"></i>
                        <div class="tw-flex tw-w-full tw-flex-col tw-text-[14px] tw-leading-snug">
                          <span v-text="'Date of delivery:'"/>
                          <strong v-text="delivery.arrival_date"/>
                        </div>
                      </div>
                      <div class="tw-flex tw-items-start tw-gap-[5px]">
                        <i class="icony icony-clock-circle tw-w-[14px] tw-max-w-[14px] tw-min-w-[14px] tw-mt-[2px] tw-text-[#8F3985]"></i>
                        <div class="tw-flex tw-w-full tw-flex-col tw-text-[14px] tw-leading-snug">
                          <span v-text="'Show up time:'"/>
                          <strong v-text="delivery.arrival_time"/>
                        </div>
                      </div>
                      <div class="tw-flex tw-items-start tw-gap-[9px]">
                        <i class="icony icony-dollar-circle tw-w-[15px] tw-max-w-[15px] tw-min-w-[15px] tw-mt-[2px] tw-text-[#8F3985]"></i>
                        <div class="tw-flex tw-w-full tw-flex-col tw-text-[14px] tw-leading-snug">
                          <span v-text="'Order price:'"/>
                          <strong v-if="isCustomer" v-text="'$' + delivery.invoice.total_price"/>
                          <strong v-else v-text="'$' + delivery.price"/>
                        </div>
                      </div>
                    </div>
                  </div>

                    <dashboard-delivery-card-actions
                        :delivery="delivery"
                        :shouldAccept="shouldAccept"
                        :shouldCancel="shouldCancel"
                    />
                </div>
            </v-card>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex';
import DashboardDeliveryCardDetails from '@/views/Dashboard/DashboardDeliveryCardDetails.vue';
import DashboardDeliveryCardActions from '@/views/Dashboard/DashboardDeliveryCardActions.vue';
import dayjs from 'dayjs';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';
import { convertSecondToTime } from '@/plugins/helpers.js';
import DeliveryCardDetails from '@/components/Modals/DeliveryCardAction.vue';
import { EventBus } from '@/main';
import { DASHBOARD_URL } from '@/plugins/consts';
import DeliveryReviews from '@/components/Modals/DeliveryReviews.vue';
import { isBeingCompletedDeliveryOrder } from '@/plugins/delivery_order_methods';

dayjs.extend(utc);
dayjs.extend(timezone);

export default {
    components: {
        DashboardDeliveryCardDetails,
        DashboardDeliveryCardActions,
    },

    props: {
        delivery: {
            type: Object,
            required: true,
        }
    },

    data() {
        return {
            orderDetails: {},
            isCardOpened: false,
            timeDiff: 0,
            interval: null,
            shouldAccept: false,
            shouldCancel: false,
        }
    },

    methods: {
        ...mapActions('orders', { showHelperOrder: 'show' }),
        ...mapActions('user_orders', { showCustomerOrder: 'show' }),
        ...mapActions('review', ['get_reviews_from_helpers_to_customer']),
        ...mapActions('dashboard', ['getDetailedDelivery']),

        isBeingCompletedDeliveryOrder,

        async openDeliveryDetailsModal(id) {
            await this.getDetailedDelivery(id);

            this.$modal.show(DeliveryCardDetails, {
                deliveryDetails: this.detailedDelivery
            }, {
                width: 1200,
                height: 'auto',
            }, {
                'before-open': this.$scrollLock.enable,
                'before-close': this.$scrollLock.disable,
            });
            EventBus.$on('acceptDelivery', () => {
                this.shouldAccept = true;
            });
            EventBus.$on('cancelDelivery', () => {
                this.shouldCancel = true;
            });
        },

        getDate(date) {
            return date ? date.split(' ')[0] : ''
        },

        async openDeliveryReviewModal () {
          const { data: reviews } = await this.get_reviews_from_helpers_to_customer(this.delivery.customer.id);

          this.$modal.show(DeliveryReviews, {
            reviews: reviews ?? [],
          }, {
            width: 800,
            height: 600,
          })
        },
    },

    computed: {
        ...mapGetters('auth', ['isCustomer']),
        ...mapState('dashboard', ['detailedDelivery']),

        showUpOrderTime() {
            return !this.isCustomer && this.timeDiff && this.delivery.status !== 'Rejected' && this.delivery.status !== 'Canceled' && this.delivery.status !== 'Accepted'
        },

        getVehicle() {
            const vehicle = this.delivery.vehicle;

            if (vehicle) {
                const slug = vehicle.toLowerCase();
                return {
                    name: vehicle,
                    image: `${ DASHBOARD_URL }/assets/images/vehicles/${ slug }.svg`,
                }
            }
        },
    },

    mounted() {
        this.interval = setInterval(() => {
            const a = new Date(this.delivery.till_auto_reject);
            const b = new Date(dayjs().tz('America/Los_Angeles').format('YYYY-MM-DD HH:mm:ss'));

            const difference = a - b;

            this.timeDiff = difference > 0
                ? convertSecondToTime(difference)
                : null;
        }, 1000);
    },

    destroyed() {
        clearInterval(this.interval);
    }
}
</script>
